import { render, staticRenderFns } from "./OnBoardingDetails.vue?vue&type=template&id=57036ea9"
import script from "./OnBoardingDetails.vue?vue&type=script&lang=js"
export * from "./OnBoardingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports